import React from 'react'
import { Info, Users, ShoppingBag, FileText } from 'lucide-react'

interface SummaryItemProps {
  icon: React.ComponentType<{ className?: string }>;
  description: string;
  amount: string;
  date: string;
  type: string;
  darkMode: boolean;
}

const SummaryItem = ({ icon: Icon, description, amount, date, type, darkMode }: SummaryItemProps) => (
  <li className="flex items-center justify-between py-3">
    <div className="flex items-center">
      <Icon className={`mr-3 h-5 w-5 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
      <div>
        <p className={`text-sm md:text-base ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>{description}</p>
        <p className={`text-xs md:text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>{type} • {date}</p>
      </div>
    </div>
    <span className={`text-sm md:text-base font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>{amount}</span>
  </li>
)

interface IncomeExpenseSummaryProps {
  darkMode: boolean;
}

const IncomeExpenseSummary = ({ darkMode }: IncomeExpenseSummaryProps) => {
  return (
    <div className={`rounded-lg shadow p-4 md:p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className={`text-lg md:text-xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>Résumé des entrées et des sorties</h2>
        <Info className={darkMode ? 'text-gray-400' : 'text-gray-500'} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Balance</p>
          <p className={`text-lg md:text-xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>- 3 904,30 EUR</p>
        </div>
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Entrées</p>
          <p className="text-lg md:text-xl font-semibold text-green-600 dark:text-green-400">+ 0,00 EUR</p>
        </div>
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Sorties</p>
          <p className="text-lg md:text-xl font-semibold text-red-600 dark:text-red-400">- 3 904,30 EUR</p>
        </div>
      </div>
      <div className={`mb-6 h-48 rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
        {/* Placeholder for the graph */}
        <p className={`text-center pt-20 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Graph placeholder</p>
      </div>
      <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Principales sorties</h3>
      <ul>
        <SummaryItem icon={Users} description="John Doe Company" amount="- 1500,72 EUR" date="7 févr." type="Virement" darkMode={darkMode} />
        <SummaryItem icon={ShoppingBag} description="Achat ordinateur" amount="- 1335,88 EUR" date="8 févr." type="Virement" darkMode={darkMode} />
        <SummaryItem icon={FileText} description="Impôts" amount="- 957,00 EUR" date="16 févr." type="Prélèvement" darkMode={darkMode} />
      </ul>
    </div>
  )
}

export default IncomeExpenseSummary